import { useState, useRef, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  CardActions,
  Chip,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  TextField,
  Typography,
  useMediaQuery
} from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import MainCard from '../MainCard';
import Transitions from './Transitions';
import NotificationList from './NotificationList';

// assets
import { IconBell } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from 'Hooks/UserContext';
import NotificationState from 'Hooks/Notification.state';
import AuthState from 'Hooks/Authinctication.state';
import DriveWithUsState from 'Hooks/DriveWithUs.state';
import NotificationDropdown from 'Component/NotificationDropDown';

// notification status options
const status = [
  {
    value: 'all',
    label: 'All Notification'
  },
  {
    value: 'new',
    label: 'New'
  },
  {
    value: 'unread',
    label: 'Unread'
  },
  {
    value: 'other',
    label: 'Other'
  }
];

// ==============================|| NOTIFICATION ||============================== //


const NotificationSection = () => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [filterdNotification, setFilterdNotification] = useState([])
  const navigate = useNavigate()
  const [ws, setWs] = useState(null);
  const anchorRef = useRef(null);
  const { notificcations, setNotifications, notificationRes } = useContext(UserContext)
  const { UpdateNotification } = NotificationState()
  const { GetUserProfile } = AuthState()
  const { GetDriveWithUs } = DriveWithUsState()

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    handleNotification()
  };

console.log()
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  // useEffect(() => {
  //   if (Object.keys(notificationRes).length !== 0) {
  //     const updateIds = notificationRes.map(notification => notification._id);
  //     const updatedAllNotifications = notificcations.map(notification => {
  //       if (updateIds.includes(notification._id)) {
  //         return { ...notification, status: 'read' };
  //       }
  //       return notification;
  //     });
  //     setNotifications(updatedAllNotifications);
  //   }
  // }, [notificationRes])

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);



  const handleNotification = () => {
    const ids = notificcations.filter((item) => item.status === "unread").map((item) => item._id)
    console.log(ids)
    if (ids.length !== 0) {

      UpdateNotification(ids)
    }



  }

  useEffect(()=>{
     const filtederNotifictions = notificcations.filter((item)=>item.status==="unread")
     setFilterdNotification(filtederNotifictions)

  },[notificcations])

 

  return (
    <>
    <NotificationDropdown notifications={filterdNotification} onClear={()=>{setFilterdNotification([])}} />
      {/* <Box
        sx={{
         
         
          
        }}
      >
        <ButtonBase sx={{ borderRadius: '12px' }}>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: 'all .2s ease-in-out',
              background: "transparent",
              color: theme.palette.secondary.dark,
              '&[aria-controls="menu-list-grow"],&:hover': {
                background: "transparent",
                color: theme.palette.secondary.light
              },
              position: "relative"
            }}
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            color="inherit"

          >
            <Box sx={{ backgroundColor: "#ffc107", height: 15, width: 15, position: "absolute", top: 2, right: 2, borderRadius: 50, fontSize: 12, display: "flex", justifyContent: "center", alignItems: "center", color: "#FFF" }} >{notificcations.slice(0, 10).length}</Box>
            <IconBell stroke={1.5} size="1.7rem" color='#fff' />

          </Avatar>
        </ButtonBase>
      </Box> */}
      {/* <Popper
        
        open={open}
        placement="bottom-start"
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        sx={{ zIndex: 9 }}
       
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [matchesXs ? -15 : 0, 20]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions position={matchesXs ? 'top' : 'top-right'} in={open} {...TransitionProps}>
            <Paper sx={{mx:5}} >
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}  >
                  <Grid container direction="column" spacing={2}>
                    <Grid item xs={12}>
                      <Grid container alignItems="center" justifyContent="space-between" sx={{ pt: 2, px: 2 }}>
                        <Grid item>
                          <Stack direction="row" spacing={2}>
                            <Typography variant="subtitle1">All Notification</Typography>
                            <Chip
                              size="small"
                              label={notificcations.slice(0, 10).length}
                              sx={{
                                color: theme.palette.background.default,
                                bgcolor: theme.palette.warning.dark
                              }}
                            />
                          </Stack>
                        </Grid>

                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 405px)', overflowX: 'hidden' }}>
                        <Grid container direction="column" spacing={2}>

                          <Grid item xs={12} p={0}>
                            <Divider sx={{ my: 0 }} />
                          </Grid>
                        </Grid>
                        <NotificationList data={notificcations} />
                      </PerfectScrollbar>
                    </Grid>
                  </Grid>
                  <Divider />
                 
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper> */}
    </>
  );
};

export default NotificationSection;
